import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconToiletPaper: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconToiletPaper"><Path d="M7 3.5H17.5C19.1569 3.5 20.5 6.18629 20.5 9.5V20.5H10.5V16.5M7 3.5C8.933 3.5 10.5 6.41015 10.5 10M7 3.5C5.067 3.5 3.5 6.41015 3.5 10C3.5 13.5899 5.067 16.5 7 16.5M10.5 10C10.5 13.5899 8.933 16.5 7 16.5M10.5 10V16.5M7 16.5H10.5" stroke="currentColor"/><Path d="M7.75 10C7.75 10.6904 7.41421 11.25 7 11.25C6.58579 11.25 6.25 10.6904 6.25 10C6.25 9.30964 6.58579 8.75 7 8.75C7.41421 8.75 7.75 9.30964 7.75 10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconToiletPaper;
